import React from 'react';
import { SummaryType } from '@ls/grouping-service';
import { titleCase } from '@ls/js-utils';
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_DEFINITION } from './actions';
import CalcType from 'state/Constants/CalcType';
import SelectionState from 'state/selections/SelectionState';
import { selectDefinitions, selectFetchingData, selectFetchingVarSbsData } from 'state/scan2/selectors';
import { selectSideBySideValue } from "state/selections/selectors";

export const useColumnDefs = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const sideBySideValue = useSelector(
    selectSideBySideValue(SelectionState.COMMITTED)
  );
  const fetchingAbsVarSbsData = useSelector(
    selectFetchingVarSbsData(SummaryType.ABSOLUTE)
  );
  const fetchingRelVarSbsData = useSelector(
    selectFetchingVarSbsData(SummaryType.RELATIVE)
  );
  const dispatch = useDispatch();

  return React.useMemo(() => {
    return definitions.reduce((columnDefs, definition) => {
      const { scan2CalcType, percentiles, calcType, key } = definition;
      const columnDef = {
        field: key,
        colId: key,
        X_onDelete: () => dispatch({ type: DELETE_DEFINITION, payload: definition }),
      }
      switch (calcType) {
        case CalcType.Account:
          columnDef.headerName = `VaR Acct  ${titleCase(scan2CalcType)} ${percentiles} %`;
          columnDef.loading = fetchingAbsData;
          break;
        case CalcType.Relative:
          columnDef.headerName = `VaR Rel ${titleCase(scan2CalcType)} ${percentiles} %`;
          columnDef.loading = fetchingRelData;
          break;
        case CalcType.Benchmark:
          columnDef.headerName = `VaR Bench ${titleCase(scan2CalcType)} ${percentiles} %`;
          columnDef.loading = fetchingAbsData;
          break;
        default:
          throw Error('Unknown calc type: ' + calcType);
      }

      columnDefs.push(columnDef);
      if (sideBySideValue) {
        const sbsColDef = { ...columnDef };
        sbsColDef.colId += " - scenario";
        sbsColDef.field += " - scenario";
        sbsColDef.headerName += " - scenario";
        switch (calcType) {
          case CalcType.Account:

            sbsColDef.loading = fetchingAbsVarSbsData;
            break;
          case CalcType.Relative:

            columnDef.loading = fetchingRelVarSbsData;
            break;
          case CalcType.Benchmark:
            sbsColDef.loading = fetchingAbsVarSbsData && fetchingRelVarSbsData;
            break;
          default:
            throw Error('Unknown calc type: ' + calcType);
        }
        sbsColDef.X_sbs = true;
        sbsColDef.X_originalColId = key;
        sbsColDef.X_backgroundColor = "#fffb95";
        columnDefs.push(sbsColDef);
      }
      return columnDefs;
    }, []);
  }, [dispatch, definitions, fetchingAbsData, fetchingRelData, sideBySideValue, fetchingAbsVarSbsData, fetchingRelVarSbsData]);
}
